import React from 'react'
import './styles.scss'

export const Chart = ({
  children,
  update,
  title,
  sub,
  source,
  footnote
}: {
  children?: React.ReactChild
  update?: string
  title?: string
  sub?: string
  footnote?: string | React.ReactChild
  source?: string | React.ReactChild
}) => {
  return (
    <div className='Chart'>
      {update && <div className='updatenote'>{update}</div>}
      {title && <div className='title'>{title}</div>}
      {sub && <div className='sub'>{sub}</div>}{' '}
      <div className='chart'>{children && children}</div>
      {(footnote || source) && <div className='spacer' />}
      {footnote && <div className='source'>{footnote}</div>}
      {source && <div className='source'>{source}</div>}
    </div>
  )
}
